module.exports = __webpack_public_path__ + "img/projector.6f12854d.svg";